<template> 
   <div style="overflow:hidden">
    <component :is="billQueryControl"  v-show="!showHead" ref="list" :config="billQueryList"  :dictData="globalConfig.dictData" @dbclick="dbclick" :toolConfig="billHead.toolbar" @doAction="_actionMethod"/>
    <component :is="billHeadControl" v-show="showHead" ref="head" :config="billHead"  :dictData="globalConfig.dictData" @doAction="_actionMethod"/>
    <component :is="billImportControl" ref="billImport" :config="billImportConfig" @importSuccess="importSuccess"/> 
    </div>
</template>
<script>
    import Base from './layoutbase.vue';
    export default {
        name: 'standarbill',
        extends: Base,
        created () {
            this.initBillQueryList();
            this.initBillHead();
            this.initDict();  
        },
        methods:{        
        },
        mounted (){
            this.doFirstSteps();
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/layout/standardbill.vue